import { getUrlRootPath } from '@ms/yammer-libs-url-path-support';

import type { TelemetryEvent } from '../../events';

type AddUrlRootPathToEventMiddleware = (event: TelemetryEvent) => Promise<TelemetryEvent>;
export const addUrlRootPathToEventMiddleware: AddUrlRootPathToEventMiddleware = async (event) =>
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  ({
    ...event,
    properties: {
      ...event.properties,
      urlRootPath: getUrlRootPath(window.location.pathname),
    },
  }) as TelemetryEvent;
